import React from 'react';
import { ProductDetailedLocation } from '../../Components/ProductAddress';
import { useSelector } from 'react-redux';
import { selectActiveProduct } from 'core/redux/features/products/reducers/products';
import { ProductTimeList } from '../../Components/ProductTimes';
import { useTrans } from 'core/hooks';
import ProductTags from '../../Components/ProductTags';
import { IProduct } from 'core/redux/features/products/types';
import { selectAllGroupTags } from 'core/redux/features/filters/categories/reducers';
import { TransFn } from 'core/redux/features/languages/trans';
import { selectActiveProductInfo } from 'core/redux/features/products/reducers/productInfos';

export function ProductName({ product }: { product: IProduct }) {
  return <h1 className="product__name">{product?.name}</h1>;
}

export function ProductShortDescription({ product }: { product: IProduct }) {
  return (
    <p className="product__desc product__desc--small">
      {product?.short_description?.replace(/^\s+|\s+$/g, '')}
    </p>
  );
}

export function ProductTime({
  product,
  trans,
  showLabel = true,
}: {
  product: IProduct;
  trans: TransFn;
  showLabel?: boolean;
}) {
  return (
    <>
      {showLabel ? (
        <p className="product__desc product__desc--time">
          {trans('times_of_today') || 'TIMES OF TODAY'}
        </p>
      ) : null}
      <div className="list-showcase product__desc product__desc--timelist">
        <div className="list-showcase__icon list-showcase__icon--clock" />
        {product ? (
          <ProductTimeList
            label={trans(`times_of_today_${product.product_type}`)}
            disabledEllipsis={true}
            product={product}
          />
        ) : null}
      </div>
    </>
  );
}

export function ProductHeadInfo() {
  const product = useSelector(selectActiveProduct);
  const productInfo = useSelector(selectActiveProductInfo);
  // const tagGroups = useSelector(selectAllGroupTags);
  const trans = useTrans();

  return (
    <div data-testid="productPage.headInfo" className="">
      <div className="content-header">
        <ProductName product={product} />
        <ProductDetailedLocation
          className="product__address"
          product={productInfo}
        />
        <ProductShortDescription product={product} />
        <ProductTime product={product} trans={trans} />

        {/*{product ? (*/}
        {/*  <ProductTags product={product} tagGroups={tagGroups} />*/}
        {/*) : null}*/}
      </div>
    </div>
  );
}
